// One `/analytics/series` read (goals/admin-panel/DESIGN.md "Analytics read
// API"), shared by the analytics pages.
import { api } from "./api";
import type { AnalyticsMetric } from "./analytics";
import type { Bucket } from "./growth";
import { unwrap } from "./problem";

export async function readSeries(
  metric: AnalyticsMetric,
  from: string,
  to: string,
  bucket: Bucket,
  options: { group?: string; filter?: string } = {},
) {
  return unwrap(
    await api.GET("/analytics/series", {
      params: {
        query: {
          metric,
          from,
          to,
          bucket,
          ...(options.group ? { group: options.group } : {}),
          ...(options.filter ? { filter: options.filter } : {}),
        },
      },
    }),
  );
}
